import axiosInstance from "../axios_instance";

export async function createDepartment(body) {
  try {
    const url = `departments/`
    return await axiosInstance.post(url, body);
  } catch (error) {
    return error;
  }
}

export async function updateDepartment(body, id) {
  try {
    const url = `departments/${id}`
    return await axiosInstance.put(url, body);
  } catch (error) {
    return error;
  }
}

export async function getDepartments(obj) {
  const params = new URLSearchParams();
  if (obj?.department) {
    params.append('name', obj?.department);
  }
  try {
    const url = `departments/${params.toString() ? `?${params.toString()}` : ''}`;
    return await axiosInstance.get(url);
  } catch (error) {
    return error;
  }
}

export async function deleteDepartment(body, id) {
  try {
    const url = `departments/${id}`
    return await axiosInstance.delete(url, body);
  } catch (error) {
    return error;
  }
}
